import { useEffect, useState } from "react";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { canContinue, getColorsByCodeId } from "./hyperFlowApi";
import { QRCodeSVG } from "qrcode.react";
import Vigilado from "../assets/vigilado.png";
import { useHistory } from "react-router-dom";

const HyperFlowContinue = () => {
  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  //query params
  const query = useQuery();
  const code = query.get("code") ?? "error";
  const history = useHistory();
  //State selectors

  //local states
  const [bgColor, setBgColor] = useState(["#ffffff", "#ffffff"]);
  const [primaryButtonColor, setPrimaryButtonColor] = useState("#ffffff");
  const [secondaryButtonColor, setSecondaryButtonColor] = useState("#ffffff");
  const [primaryTextColor, setPrimaryTextColor] = useState("#ffffff");
  const [secondaryTextColor, setSecondaryTextColor] = useState("#ffffff");
  const [terciaryTextColor, setTerciaryTextColor] = useState("#ffffff");
  const [logo, setLogo] = useState("");
  const [font, setFont] = useState<string | null>(null);
  const [vigilado, setVigilado] = useState(false);
  const [redirectOnDesktop, setRedirectOnDesktop] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [url, setUrl] = useState("");
  const [continueMessage, setContinueMessage] = useState(
    "Continuemos con tu proceso"
  );
  const [errorMessage, setErrorMessage] = useState("");
  //sms screen
  const [showSendSMS, setShowSendSMS] = useState(false);
  const [noCelular, setNoCelular] = useState("");
  const [confirmNoCelular, setConfirmNoCelular] = useState("");

  const fontDictionary: { [key: string]: string } = {
    default: "'Open Sans', sans-serif",
    sourceSans: "'Source Sans 3', sans-serif",
  };
  const userAgent = navigator.userAgent || navigator.vendor;
  function isIOS() {
    return /iPhone|iPad|iPod/i.test(userAgent);
  }

  /**
   * Checks if the current platform is Android.
   *
   * @returns true if the platform is Android, false otherwise.
   */
  function isAndroid() {
    return /Android/i.test(userAgent);
  }

  /**
   * Checks if the current platform is a mobile device.
   *
   * @returns true if the platform is a mobile device, false otherwise.
   */
  function isMobile() {
    return isIOS() || isAndroid();
  }

  const getFontFamily = () => {
    if (font) {
      return fontDictionary[font];
    } else {
      return fontDictionary.default;
    }
  };

  //get colors
  async function getColors() {
    let resp = await getColorsByCodeId(code);

    setBgColor([resp.backgroundColor1, resp.backgroundColor2]);
    setPrimaryButtonColor(
      resp.primaryButtonColor ||
        "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)"
    );
    setSecondaryButtonColor(
      resp.secondaryButtonColor ||
        "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)"
    );

    if (resp.primaryTextColor) {
      setPrimaryTextColor(resp.primaryTextColor);
    } else {
      setPrimaryTextColor(darkMode ? "white" : "black");
    }
    if (resp.secondaryTextColor) {
      setSecondaryTextColor(resp.secondaryTextColor);
    } else {
      setSecondaryTextColor(darkMode ? "white" : "black");
    }

    setTerciaryTextColor(resp.tertiaryTextColor || "#ffff");
    setLogo(resp.logoUrl || "");
    setFont(resp.font);
    setDarkMode(resp.darkMode);
    setVigilado(resp.vigilado || false);
  }

  async function canContinueF() {
    setLoading(true);
    let resp = await canContinue(code);
    console.log(resp);
    let userAction = "WAIT";
    if (resp) {
      setContinueMessage(resp.message ?? "");
      // setStatus(resp.userAction);
      userAction = resp.userAction;
      if (resp.url) {
        setUrl(resp.url);
      }
      if (resp.redirectOnDesktop) {
        setRedirectOnDesktop(resp.redirectOnDesktop);
      }
    }
    setLoading(false);
    let keepAsking = false;
    if (
      userAction === "WAIT" ||
      userAction === "DONT_WAIT" ||
      userAction === "WAIT_EMAIL"
    ) {
      keepAsking = true;
      setStatus(userAction);
    } else {
      if (resp?.autoAdvance === true && userAction === "CONTINUE") {
        if (!isMobile() && resp?.redirectOnDesktop) {
          return;
        }
        console.log(resp?.url ?? "");
        window.location.href = resp?.url ?? "";
        return;
      }
      if (resp?.message !== null && resp?.message !== "") {
        setContinueMessage(resp?.message ?? "Continuemos con tu proceso");
        setErrorMessage(
          resp?.message ??
            "Tu proceso está en revisión, te enviaremos un correo para continuar"
        );
      }
      keepAsking = false;
    }
    if (!keepAsking) {
      setStatus(userAction);
    }

    while (keepAsking) {
      await delay(5000);
      console.log("keep asking");
      let resp = await canContinue(code);
      console.log(resp);
      if (resp) {
        // setStatus(resp.userAction);
        userAction = resp.userAction;
        if (resp.url) {
          setUrl(resp.url);
        }
      }
      if (userAction === "WAIT" || userAction === "DONT_WAIT") {
        keepAsking = true;
        setStatus(userAction);
      } else if (userAction === "ABANDON") {
        keepAsking = false;
        setStatus(userAction);
        setContinueMessage(resp?.message ?? "Su proceso ha sido abandonado");
      } else {
        if (resp?.autoAdvance === true && userAction === "CONTINUE") {
          console.log(resp?.url ?? "");
          if (!isMobile() && resp?.redirectOnDesktop) {
            return;
          }
          window.location.href = resp?.url ?? "";
          return;
        }
        setStatus(userAction);
        if (resp?.message !== null && resp?.message !== "") {
          setContinueMessage(resp?.message ?? "Continuemos con tu proceso");
        }
        keepAsking = false;
      }
    }
  }

  const phoneContent = () => {
    return (
      <div
        style={{
          background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
          position: "fixed",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: "50%",
          }}
        >
          {loading && (
            <div>
              <h1
                style={{
                  fontSize: "26px",
                  marginBottom: "50px",
                  fontWeight: 600,
                  color: primaryTextColor,
                }}
              >
                Espere un momento
              </h1>
              <ClipLoader
                loading={loading}
                size={150}
                color={primaryTextColor}
              />
            </div>
          )}

          {!loading && (
            <div>
              {status === "WAIT" && (
                <div>
                  <h1
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  >
                    Espere un momento, estamos procesando su información
                  </h1>
                  <ClipLoader
                    loading={true}
                    size={150}
                    color={primaryTextColor}
                  />
                </div>
              )}
              {status === "ABANDON" && (
                <div>
                  <h1
                    style={{
                      fontSize: "22px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                      width:"85vw",

                    }}
                  >
                    {continueMessage}
                  </h1>
                </div>
              )}
              {status === "WAIT_EMAIL" && (
                <div>
                  <h1
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  >
                    Continua tu proceso desde tu correo electrónico
                  </h1>
                </div>
              )}
              {status === "DONE" && (
                <div className="w-full flex flex-col justify-center items-center">
                  <h1
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  >
                    ¡Su proceso ha terminado!
                  </h1>
                  <div
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  ></div>
                  <button
                    className="flex justify-center items-center text-[16px] font-semibold min-w-[160px] min-h-[56px] rounded-[30px]"
                    onClick={() => {
                      window.location.href = url;
                    }}
                    style={{
                      background: primaryButtonColor,
                      color: terciaryTextColor,
                    }}
                  >
                    Terminar
                  </button>
                </div>
              )}
              {status === "CONTINUE" && (
                <div className="w-full flex flex-col justify-center items-center">
                  <h1
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  >
                    {continueMessage}
                  </h1>
                  <button
                    className="flex justify-center items-center text-[16px] font-semibold min-w-[160px] min-h-[56px] rounded-[30px]"
                    style={{
                      background: primaryButtonColor,
                      color: terciaryTextColor,
                    }}
                    onClick={() => {
                      window.location.href = url;
                    }}
                  >
                    Continuar
                  </button>
                </div>
              )}
              {status === "DONT_WAIT" && (
                <div className="w-full flex flex-col justify-center items-center">
                  <h1
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  >
                    Su proceso está en revisión. Le enviaremos un correo para
                    continuar.
                  </h1>
                  <h1
                    style={{
                      fontSize: "26px",
                      marginBottom: "50px",
                      fontWeight: 600,
                      color: primaryTextColor,
                    }}
                  >
                    Puede cerrar esta ventana
                  </h1>
                  <ClipLoader
                    loading={true}
                    size={150}
                    color={primaryTextColor}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const desktopContent = () => {
    if (showSendSMS) {
      return (
        <div className="w-full h-full flex flex-col justify-center items-center">
          {vigilado && (
            <img
              className="absolute left-[5%] sm:left-[15%] lg:left-[25%] xl:left-[30%]"
              src={Vigilado}
              alt="Vigilado SuperIntendencia financiera"
            />
          )}
          {logo && (
            <img
              className="xl:w-[24%] sm:w-[40%] w-[50%]"
              src={logo}
              style={{ height: "auto" }}
              alt="Logo"
            />
          )}
          <h1
            className="text-center text-[30px] leading-[30px] font-semibold mb-[10px] mt-[20px]"
            style={{
              color: primaryTextColor,
            }}
          >
            Ingresa tu número de celular
          </h1>
          <form
            className="w-[50%] flex flex-col justify-center items-center my-[40px] "
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <input
              placeholder="No. DE CELULAR"
              style={{
                borderColor: primaryTextColor,
                color: primaryTextColor,
              }}
              className="bg-transparent border-[1px] rounded-[8px] text-center justify-center items-center w-[350px] h-[38px] my-[12px]"
              type="number"
              value={noCelular}
              inputMode="tel"
              onChange={(ev) => {
                // regex for only digits
                const regex = /^[0-9\b]+$/;
                if (ev.target.value === "" || regex.test(ev.target.value)) {
                  setNoCelular(ev.target.value);
                }
              }}
            />
            <input
              placeholder="CONFIRMAR No. DE CELULAR"
              style={{
                borderColor: primaryTextColor,
                color: primaryTextColor,
              }}
              className="bg-transparent border-[1px] rounded-[8px] text-center justify-center items-center w-[350px] h-[38px] my-[12px]"
              type="number"
              value={confirmNoCelular}
              inputMode="tel"
              onChange={(ev) => {
                // regex for only digits
                const regex = /^[0-9\b]+$/;
                if (ev.target.value === "" || regex.test(ev.target.value)) {
                  setConfirmNoCelular(ev.target.value);
                }
              }}
            />

            <button
              className="flex justify-center items-center text-[16px] font-semibold min-w-[160px] min-h-[56px] rounded-[30px] mt-10"
              onClick={() => {}}
              style={{
                background: primaryButtonColor,
                color: terciaryTextColor,
              }}
            >
              Enviar
            </button>
          </form>
          <h2
            onClick={() => {
              setShowSendSMS(false);
            }}
            className="text-center text-[20px] leading-[20px] font-bold mt-[20px] cursor-pointer"
            style={{
              color: primaryTextColor,
            }}
          >
            ¿Prefieres ingresar mediante código QR?
          </h2>
        </div>
      );
    } else {
      return (
        <div className="w-full h-full flex flex-col justify-center items-center">
          {vigilado && (
            <img
              className="absolute left-[5%] sm:left-[10%] lg:left-[20%] xl:left-[28%]"
              src={Vigilado}
              alt="Vigilado SuperIntendencia financiera"
            />
          )}
          {logo && (
            <img
              className="xl:w-[24%] sm:w-[40%] w-[50%]"
              src={logo}
              style={{ height: "auto" }}
              alt="Logo"
            />
          )}
          <h1
            className="text-center text-[24px] leading-[24px] font-semibold mb-[40px]"
            style={{
              color: primaryTextColor,
            }}
          >
            Te invitamos a continuar con la solicitud de producto <br />
            desde tu dispositivo móvil, escaneando este código.
          </h1>
          <QRCodeSVG
            value={`${window.location.origin}${history.location.pathname}?code=${code}`}
            size={280}
            includeMargin={true}
          />
          <h2
            className="text-center text-[24px] leading-[24px]  font-semibold mt-[40px]"
            style={{
              color: primaryTextColor,
            }}
          >
            Si no cuentas con lector de código QR, puedes
            <br />
            descargar uno de forma gratuita desde la tienda de <br />
            aplicaciones de tu dispositivo
          </h2>
          <div className="flex flex-row w-[40%] sm:w-[35%] lg:w-[30%] xl:w-[20%] justify-evenly items-center my-[15px]">
            <a href="https://play.google.com/store/search?q=qr%20reader&c=apps&hl=es">
              <svg
                className="cursor-pointer"
                width="191"
                height="75"
                viewBox="0 0 191 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M91.9587 34.5536C88.8281 34.5536 86.2835 36.9308 86.2835 40.2121C86.2835 43.4766 88.8281 45.8705 91.9587 45.8705C95.0893 45.8705 97.6339 43.4766 97.6339 40.2121C97.6339 36.9476 95.0893 34.5536 91.9587 34.5536ZM91.9587 43.644C90.2511 43.644 88.7612 42.221 88.7612 40.2121C88.7612 38.1697 90.2344 36.7801 91.9587 36.7801C93.683 36.7801 95.1563 38.1697 95.1563 40.2121C95.1395 42.221 93.6663 43.644 91.9587 43.644ZM107.16 35.8259H107.076C106.523 35.1563 105.452 34.5536 104.096 34.5536C101.267 34.5536 98.6719 37.048 98.6719 40.2288C98.6719 43.3929 101.267 45.8705 104.096 45.8705C105.452 45.8705 106.523 45.2679 107.076 44.5815H107.16V45.4018C107.16 47.5614 106.004 48.7165 104.146 48.7165C102.623 48.7165 101.685 47.6284 101.3 46.7076L99.1406 47.6116C99.76 49.1183 101.417 50.9598 104.163 50.9598C107.076 50.9598 109.537 49.2522 109.537 45.067V34.9051H107.176L107.16 35.8259ZM104.314 43.644C102.606 43.644 101.166 42.2043 101.166 40.2288C101.166 38.2366 102.606 36.7801 104.314 36.7801C106.004 36.7801 107.327 38.2366 107.327 40.2288C107.327 42.221 106.004 43.644 104.314 43.644ZM79.5703 34.5536C76.4397 34.5536 73.8951 36.9308 73.8951 40.2121C73.8951 43.4766 76.4397 45.8705 79.5703 45.8705C82.7009 45.8705 85.2455 43.4766 85.2455 40.2121C85.2455 36.9476 82.7009 34.5536 79.5703 34.5536ZM79.5703 43.644C77.8627 43.644 76.3728 42.221 76.3728 40.2121C76.3728 38.1697 77.846 36.7801 79.5703 36.7801C81.2779 36.7801 82.7679 38.1697 82.7679 40.2121C82.7511 42.221 81.2779 43.644 79.5703 43.644ZM64.8214 36.2779V38.6719H70.5636C70.3962 40.0279 69.9442 41.0156 69.2578 41.702C68.4208 42.5391 67.115 43.4598 64.8214 43.4598C61.2891 43.4598 58.5268 40.6138 58.5268 37.0815C58.5268 33.5491 61.2891 30.7031 64.8214 30.7031C66.7299 30.7031 68.1194 31.4565 69.1574 32.4107L70.8482 30.7199C69.4085 29.3471 67.5 28.2924 64.8214 28.2924C59.9833 28.2924 55.8984 32.2433 55.8984 37.0815C55.8984 41.9197 59.9665 45.8705 64.8214 45.8705C67.433 45.8705 69.4085 45.0168 70.9487 43.4096C72.5391 41.8192 73.0246 39.5926 73.0246 37.8014C73.0246 37.2489 72.9743 36.7299 72.8906 36.2947L64.8214 36.2779ZM125.089 38.1697C124.621 36.8973 123.181 34.5703 120.251 34.5703C117.338 34.5703 114.911 36.8639 114.911 40.2288C114.911 43.3929 117.305 45.8873 120.519 45.8873C123.114 45.8873 124.621 44.2969 125.24 43.3761L123.315 42.0871C122.679 43.0246 121.791 43.644 120.536 43.644C119.28 43.644 118.376 43.058 117.79 41.9364L125.357 38.8058L125.089 38.1697ZM117.388 40.0447C117.321 37.8516 119.079 36.7467 120.352 36.7467C121.339 36.7467 122.176 37.2322 122.444 37.952L117.388 40.0447ZM111.228 45.5357H113.705V28.9118H111.228V45.5357ZM136.741 28.9118H130.798V45.5357H133.276V39.2411H136.741C139.487 39.2411 142.199 37.2489 142.199 34.0681C142.199 30.904 139.487 28.9118 136.741 28.9118ZM136.808 36.8973H133.276V31.2054H136.808C138.666 31.2054 139.721 32.7455 139.721 34.0514C139.721 35.3572 138.666 36.8973 136.808 36.8973ZM143.571 45.5357H146.049V28.9118H143.571V45.5357ZM152.143 34.5201C150.352 34.5201 148.477 35.3069 147.706 37.0647L149.916 37.9855C150.385 37.0647 151.256 36.7634 152.176 36.7634C153.465 36.7634 154.771 37.5335 154.788 38.9063V39.0737C154.336 38.8226 153.382 38.4375 152.193 38.4375C149.816 38.4375 147.405 39.7433 147.405 42.1875C147.405 44.4141 149.347 45.8371 151.54 45.8371C153.214 45.8371 154.135 45.0837 154.704 44.2132H154.788V45.5022H157.182V39.1239C157.199 36.1775 154.989 34.5201 152.143 34.5201ZM151.842 43.644C151.021 43.644 149.9 43.2422 149.9 42.2377C149.9 40.9487 151.306 40.4632 152.528 40.4632C153.616 40.4632 154.135 40.6976 154.788 41.0156C154.604 42.5558 153.281 43.644 151.842 43.644ZM165.921 34.8884L163.075 42.1038H162.991L160.045 34.8884H157.366L161.786 44.9665L159.258 50.5915H161.853L168.683 34.9051H165.921V34.8884Z"
                  fill={primaryTextColor}
                />
                <path
                  d="M21.9644 23.2199C21.6296 23.5715 21.4287 24.1239 21.4287 24.827V50.1563C21.4287 50.8594 21.6296 51.4119 21.9644 51.7634L22.0481 51.8471L36.2446 37.6507V37.3159L22.0481 23.1194L21.9644 23.2199Z"
                  fill="url(#paint0_linear_1_16)"
                />
                <path
                  d="M40.9656 42.3884L36.2446 37.6507V37.3159L40.9824 32.5781L41.0828 32.6451L46.6911 35.8259C48.2982 36.7299 48.2982 38.2199 46.6911 39.1406L41.0828 42.3214L40.9656 42.3884Z"
                  fill="url(#paint1_linear_1_16)"
                />
                <path
                  d="M41.0827 42.3214L36.2445 37.4833L21.9644 51.7634C22.4833 52.3159 23.3706 52.3996 24.3416 51.8304L41.0827 42.3214Z"
                  fill="url(#paint2_linear_1_16)"
                />
                <path
                  d="M41.0827 32.6618L24.3416 23.1529C23.3539 22.6004 22.4833 22.6674 21.9644 23.2198L36.2445 37.5L41.0827 32.6618Z"
                  fill="url(#paint3_linear_1_16)"
                />
                <path
                  opacity="0.2"
                  d="M40.9655 42.2209L24.3416 51.6629C23.4041 52.1986 22.5838 52.1651 22.0481 51.6797L21.9644 51.7634L22.0481 51.8471C22.5838 52.3326 23.4208 52.366 24.3416 51.8303L41.0827 42.3214L40.9655 42.2209Z"
                  fill="black"
                />
                <path
                  opacity="0.12"
                  d="M21.9644 51.596C21.6296 51.2444 21.4287 50.692 21.4287 49.9889V50.1563C21.4287 50.8594 21.6296 51.4118 21.9644 51.7634L22.0481 51.6797L21.9644 51.596ZM46.6742 38.9732L40.9655 42.221L41.066 42.3214L46.6742 39.1406C47.4778 38.6886 47.8796 38.086 47.8796 37.4833C47.8126 38.0357 47.4109 38.5547 46.6742 38.9732Z"
                  fill="black"
                />
                <path
                  opacity="0.25"
                  d="M24.3417 23.3036L46.6742 35.9933C47.3941 36.4119 47.8126 36.9308 47.8796 37.4833C47.8796 36.8806 47.4778 36.2779 46.6742 35.8259L24.3417 23.1362C22.7345 22.2322 21.4287 22.9855 21.4287 24.8103V24.9777C21.4287 23.1529 22.7345 22.3996 24.3417 23.3036Z"
                  fill="white"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1_16"
                    x1="34.9716"
                    y1="24.5515"
                    x2="15.7466"
                    y2="43.7764"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#00A0FF" />
                    <stop offset="0.007" stop-color="#00A1FF" />
                    <stop offset="0.26" stop-color="#00BEFF" />
                    <stop offset="0.512" stop-color="#00D2FF" />
                    <stop offset="0.76" stop-color="#00DFFF" />
                    <stop offset="1" stop-color="#00E3FF" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_1_16"
                    x1="48.7633"
                    y1="37.4916"
                    x2="21.0449"
                    y2="37.4916"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FFE000" />
                    <stop offset="0.409" stop-color="#FFBD00" />
                    <stop offset="0.775" stop-color="#FFA500" />
                    <stop offset="1" stop-color="#FF9C00" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_1_16"
                    x1="38.4491"
                    y1="40.1252"
                    x2="12.3788"
                    y2="66.1955"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF3A44" />
                    <stop offset="1" stop-color="#C31162" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_1_16"
                    x1="18.3684"
                    y1="14.7773"
                    x2="30.0099"
                    y2="26.4189"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#32A071" />
                    <stop offset="0.069" stop-color="#2DA771" />
                    <stop offset="0.476" stop-color="#15CF74" />
                    <stop offset="0.801" stop-color="#06E775" />
                    <stop offset="1" stop-color="#00F076" />
                  </linearGradient>
                </defs>
              </svg>
            </a>
            <a href="https://apps.apple.com/us/app/qr-code-reader/id1200318119">
              <svg
                width="147"
                height="28"
                viewBox="0 0 147 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.0398 17.5095C18.6646 18.6843 18.123 19.7994 17.4317 20.8208C16.7924 21.7554 16.2702 22.402 15.8675 22.7583C15.2453 23.3488 14.5767 23.6514 13.8593 23.6685C13.3468 23.6685 12.7295 23.5172 12.0047 23.2122C11.28 22.9071 10.6163 22.7583 10.0111 22.7583C9.37422 22.7583 8.68853 22.9096 7.95891 23.2146C7.2293 23.5196 6.6339 23.6758 6.1849 23.6929C5.49921 23.7246 4.81596 23.4123 4.13027 22.7583C3.69592 22.3703 3.14932 21.7017 2.49779 20.7525C1.7596 19.6647 1.17803 18.4786 0.770145 17.2288C0.305013 15.877 0.0611128 14.4589 0.0478516 13.0293C0.0478516 11.4725 0.374836 10.1352 1.02636 9.0152C1.5388 8.11234 2.22449 7.40225 3.07855 6.88005C3.91464 6.36613 4.87416 6.08788 5.85548 6.07479C6.39964 6.07479 7.11461 6.2456 8.0004 6.58722C8.88618 6.93129 9.45474 7.09966 9.70364 7.09966C9.8891 7.09966 10.5187 6.89713 11.5923 6.49206C12.6026 6.11871 13.4591 5.96254 14.1594 6.02598C16.0579 6.18216 17.4805 6.95081 18.4297 8.33683C16.7362 9.39831 15.8993 10.8746 15.9139 12.7706C15.9285 14.2494 16.4507 15.4768 17.4781 16.4578C17.9417 16.9116 18.4639 17.2606 19.0398 17.5095ZM14.1863 0.40625C14.2009 0.562422 14.2107 0.716153 14.2107 0.872324C14.2107 2.03873 13.7983 3.12705 12.9735 4.13728C11.9779 5.33785 10.8261 5.88201 9.52063 5.7722C9.5048 5.62469 9.49665 5.47645 9.49623 5.32809C9.49623 4.20805 9.91594 3.15877 10.7578 2.17782C11.1775 1.68002 11.7095 1.26763 12.3561 0.940649C13.0028 0.613665 13.6104 0.437972 14.1863 0.40625ZM45.3351 22.7583H42.6509L41.1795 18.1366H36.0698L34.6716 22.7583H32.0581L37.1215 7.03134H40.2474L45.3351 22.7583ZM40.7378 16.204L39.4079 12.0947C39.1142 11.1153 38.8498 10.1274 38.6149 9.13233H38.5685C38.4124 9.80094 38.1635 10.7892 37.8218 12.0947L36.5163 16.204H40.7378ZM58.2608 16.9482C58.2608 18.876 57.7361 20.4011 56.6893 21.5211C56.246 22.0042 55.7048 22.3872 55.1019 22.6447C54.4989 22.9022 53.848 23.0283 53.1925 23.0145C51.6918 23.0145 50.6108 22.4777 49.9544 21.404V27.3532H47.4337V15.1474C47.4337 13.9346 47.402 12.6926 47.3385 11.4188H49.5567L49.6957 13.2148H49.7421C50.5815 11.8605 51.8577 11.187 53.5683 11.187C54.9055 11.187 56.0207 11.7165 56.9162 12.7706C57.8118 13.8297 58.2608 15.2206 58.2608 16.9482ZM55.6937 17.041C55.6937 15.938 55.4448 15.0278 54.947 14.3128C54.7044 13.9574 54.3764 13.6685 53.9931 13.4728C53.6098 13.2771 53.1835 13.1808 52.7533 13.1928C52.131 13.1928 51.5674 13.3978 51.0622 13.8102C50.556 14.2221 50.2056 14.7946 50.0691 15.4329C50.0003 15.6836 49.9618 15.9416 49.9544 16.2015V18.0902C49.9544 18.915 50.2082 19.6105 50.7133 20.1766C51.2184 20.7427 51.8773 21.0282 52.685 21.0282C53.6342 21.0282 54.3711 20.6646 54.9007 19.9326C55.4302 19.2054 55.6937 18.2415 55.6937 17.041ZM71.5842 16.9482C71.5842 18.876 71.0595 20.4011 70.0127 21.5211C69.5694 22.0042 69.0282 22.3872 68.4253 22.6447C67.8223 22.9022 67.1714 23.0283 66.5159 23.0145C65.0152 23.0145 63.9342 22.4777 63.2778 21.404V27.3532H60.7571V15.1474C60.7571 13.9346 60.7254 12.6926 60.6619 11.4188H62.88L63.0191 13.2148H63.0655C63.9049 11.8605 65.1811 11.187 66.8917 11.187C68.2289 11.187 69.3441 11.7165 70.2396 12.7706C71.1352 13.8297 71.5842 15.2206 71.5842 16.9482ZM69.0171 17.041C69.0171 15.938 68.7682 15.0278 68.2704 14.3128C68.0278 13.9574 67.6998 13.6685 67.3165 13.4728C66.9332 13.2771 66.5069 13.1808 66.0767 13.1928C65.4544 13.1928 64.8907 13.3978 64.3856 13.8102C63.8794 14.2221 63.529 14.7946 63.3925 15.4329C63.3236 15.6836 63.2851 15.9416 63.2778 16.2015V18.0902C63.2778 18.915 63.5316 19.6105 64.0367 20.1766C64.5418 20.7427 65.2006 21.0282 66.0083 21.0282C66.9576 21.0282 67.6945 20.6646 68.224 19.9326C68.7535 19.2054 69.0171 18.2415 69.0171 17.041ZM76.6475 22.7583H74.1268V6.21632H76.6475V22.7583ZM89.2681 16.5529C89.2681 17.0044 89.2364 17.385 89.173 17.6949H81.6133C81.645 18.815 82.0086 19.6715 82.7089 20.262C83.3458 20.7915 84.1706 21.055 85.1833 21.055C86.2263 21.0692 87.2627 20.8871 88.2384 20.5182L88.6361 22.2678C87.5625 22.7339 86.296 22.9682 84.8319 22.9682C83.075 22.9682 81.6938 22.4508 80.6909 21.4162C79.688 20.3816 79.1853 18.9931 79.1853 17.2508C79.1853 15.5402 79.6514 14.1176 80.586 12.9805C81.5645 11.7677 82.8871 11.1626 84.5513 11.1626C86.1837 11.1626 87.4209 11.7677 88.2628 12.9805C88.9338 13.9468 89.2681 15.1376 89.2681 16.5529ZM86.867 15.899C86.8989 15.2196 86.7282 14.546 86.3765 13.9639C85.9422 13.2636 85.2711 12.9122 84.3707 12.9122C83.9778 12.9058 83.5893 12.9962 83.2395 13.1753C82.8897 13.3545 82.5893 13.6169 82.3649 13.9395C81.9356 14.5088 81.6766 15.1883 81.6182 15.899H86.867ZM106.232 18.3489C106.232 19.6885 105.766 20.7769 104.836 21.6163C103.812 22.5338 102.384 22.9926 100.554 22.9926C98.8629 22.9926 97.5037 22.6656 96.4813 22.014L97.0645 19.913C98.1699 20.5695 99.3827 20.894 100.705 20.894C101.654 20.894 102.391 20.6793 102.921 20.2498C103.178 20.0467 103.384 19.7857 103.522 19.4881C103.66 19.1905 103.726 18.8646 103.714 18.5368C103.721 18.2379 103.667 17.9407 103.554 17.6637C103.442 17.3866 103.273 17.1356 103.06 16.9263C102.623 16.4919 101.901 16.0868 100.888 15.7135C98.1357 14.6862 96.7595 13.1855 96.7595 11.2089C96.7595 9.92051 97.2451 8.86147 98.2187 8.03669C99.1899 7.21435 100.478 6.80196 102.082 6.80196C103.511 6.80196 104.702 7.05086 105.652 7.54866L105.02 9.60329C104.089 9.11177 103.05 8.86252 101.999 8.87855C101.108 8.87855 100.415 9.09817 99.9146 9.53252C99.7127 9.71037 99.5516 9.92983 99.4425 10.1758C99.3334 10.4218 99.2789 10.6885 99.2826 10.9576C99.2773 11.2524 99.3396 11.5445 99.4648 11.8114C99.59 12.0784 99.7748 12.313 100.005 12.4973C100.425 12.8682 101.186 13.2733 102.291 13.7101C103.646 14.2567 104.639 14.8912 105.278 15.6232C105.913 16.3504 106.232 17.2606 106.232 18.3489ZM114.187 13.3099H111.41V18.815C111.41 20.2156 111.901 20.9135 112.879 20.9135C113.331 20.9135 113.704 20.8745 113.999 20.7988L114.07 22.7095C113.572 22.8974 112.918 22.9901 112.111 22.9901C111.115 22.9901 110.337 22.6875 109.778 22.0799C109.219 21.4723 108.938 20.4548 108.938 19.0224V13.3099H107.282V11.4188H108.938V9.34219L111.413 8.59549V11.4188H114.19L114.187 13.3099ZM126.576 16.997C126.576 18.7393 126.078 20.1693 125.083 21.2893C124.041 22.4411 122.655 23.017 120.929 23.017C119.265 23.017 117.938 22.463 116.952 21.3601C115.964 20.2547 115.471 18.8638 115.471 17.1825C115.471 15.4231 115.978 13.9834 116.998 12.8634C118.016 11.7458 119.39 11.1845 121.117 11.1845C122.782 11.1845 124.119 11.736 125.131 12.8414C126.093 13.9151 126.576 15.3011 126.576 16.997ZM123.963 17.0532C123.963 16.0136 123.738 15.123 123.287 14.3763C122.757 13.4783 122.003 13.0269 121.025 13.0269C120.012 13.0269 119.243 13.4783 118.714 14.3763C118.262 15.123 118.038 16.0307 118.038 17.0995C118.038 18.139 118.262 19.0297 118.714 19.774C119.258 20.6744 120.022 21.1258 121 21.1258C121.964 21.1258 122.718 20.6671 123.265 19.7544C123.731 18.9931 123.963 18.0927 123.963 17.0532ZM135.046 13.6369C134.784 13.5877 134.519 13.564 134.253 13.5661C133.365 13.5661 132.681 13.9029 132.198 14.5691C131.779 15.1596 131.569 15.9087 131.569 16.8091V22.7583H129.048V14.9912C129.048 13.6833 129.024 12.4949 128.977 11.4188H131.171L131.264 13.5905H131.334C131.598 12.8438 132.018 12.2436 132.594 11.7946C133.152 11.3895 133.76 11.1894 134.414 11.1894C134.646 11.1894 134.858 11.204 135.043 11.2358V13.6369H135.046ZM146.339 16.5529C146.339 17.0044 146.307 17.385 146.244 17.6949H138.684C138.716 18.815 139.08 19.6715 139.78 20.262C140.417 20.7915 141.242 21.055 142.254 21.055C143.297 21.0692 144.334 20.8871 145.309 20.5182L145.707 22.2678C144.633 22.7339 143.367 22.9682 141.903 22.9682C140.146 22.9682 138.765 22.4508 137.762 21.4162C136.759 20.3816 136.259 18.9931 136.259 17.2508C136.259 15.5402 136.725 14.1176 137.659 12.9805C138.638 11.7677 139.96 11.1626 141.625 11.1626C143.257 11.1626 144.494 11.7677 145.336 12.9805C146.005 13.9468 146.339 15.1376 146.339 16.5529ZM143.935 15.899C143.967 15.2196 143.797 14.546 143.445 13.9639C143.011 13.2636 142.34 12.9122 141.439 12.9122C141.046 12.9058 140.658 12.9962 140.308 13.1753C139.958 13.3545 139.658 13.6169 139.433 13.9395C139.004 14.5088 138.745 15.1883 138.687 15.899H143.935Z"
                  fill={primaryTextColor}
                />
              </svg>
            </a>
          </div>
          <h2
            onClick={() => {
              setShowSendSMS(true);
            }}
            className="text-center text-[20px] leading-[20px] font-bold mt-[5px] cursor-pointer"
            style={{
              color: primaryTextColor,
            }}
          >
            ¿Prefieres recibir un mensaje de texto en tu dispositivo?
          </h2>
        </div>
      );
    }
  };

  const renderContent = () => {
    if (redirectOnDesktop && !isMobile()) {
      return desktopContent();
    } else {
      return phoneContent();
    }
  };

  useEffect(() => {
    getColors();
    canContinueF();
  }, []);

  useEffect(() => {
    let styleTemp = document.createElement("style");
    if (primaryTextColor) {
      styleTemp.innerHTML = `input::placeholder { color: ${primaryTextColor}; }`;
      document.head.appendChild(styleTemp);
    }
  }, [primaryTextColor]);

  //Render
  return (
    <div
      className="flex justify-center items-center"
      style={{
        background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
        minHeight: "100vh",
        width: "100%",
        overflow: "auto",
        fontFamily: getFontFamily(),
      }}
    >
      {renderContent()}
    </div>
  );
};

export default HyperFlowContinue;
